export default function isLoggedIn(user_type) {
  if (
    localStorage.getItem('auth_token') === null ||
    localStorage.getItem('user_type') !== user_type
  ) {
    return false;
  }
  return true;
}